import "../assets/css/style.css";
import DynamicDetailGrid from "../Components/Grid/DynamicDetailGrid";
import { CustomerBillTo } from "../Pages/Outbound/Orders/model/order.model"; 
type BillToProps = {
    customer?: CustomerBillTo| null;
};

const BillToCodeLayout: React.FC<BillToProps> = ({
    customer
}) => {
    const BillToCodeLayoutData=[
        {label: "Customer Code", value: customer?.code},
        {label: "Customer Name", value: customer?.name},
        {label: "Contact Name", value: customer?.contact_name},
        {label: "Contact Email", value: customer?.contact_email},
        {label: "Contact Telephone", value: customer?.contact_phone},
        {label: "Address 1", value: customer?.address_line_1},
        {label: "Address 2", value: customer?.address_line_2},
        {label: "City", value: customer?.city},
        {label: "State", value: customer?.state_province},
        {label: "Zip Code", value: customer?.postal_code},
        {label: "Country", value: customer?.country},

    ]
    return (
          <DynamicDetailGrid customClassName="col py-0" isExpandable={false} columns={2} data={BillToCodeLayoutData} />
    )

}

export default BillToCodeLayout